import { Box, Divider, Stack, useTheme } from '@mui/material';
import { Typography } from '@chr/eds-react';
import { useTranslation } from '@chr/online-shared-ui-localizations';

import { CargoSummary, CommoditySummary, NonPurchaseOrderItem, PurchaseOrderItem } from '@/common/apis/dtos';
import { PurchaseOrderItems } from './PurchaseOrderItems';
import { NonPurchaseOrderItems } from './NonPurchaseOrderItems';
import { PurchaseOrderItemsHeader } from './PurchaseOrderItemsHeader';

export interface CargoDetailsProps {
  cargoSummary: CargoSummary;
  commoditySummary: CommoditySummary;
  purchaseOrderItems: PurchaseOrderItem[];
  nonPurchaseOrderItems: NonPurchaseOrderItem[];
}

export const CargoDetails = ({ cargoSummary, purchaseOrderItems, nonPurchaseOrderItems }: CargoDetailsProps) => {
  const translate = useTranslation();
  const theme = useTheme();

  const hasPoItems = purchaseOrderItems.length > 0;
  const hasNonPoItems = nonPurchaseOrderItems.length > 0;

  return (
    <Stack
      spacing={3}
      padding={1}
      data-testid="cargo-item-details-tab"
      sx={{
        marginBottom: (theme) => theme.spacing(2)
      }}
    >
      <Stack spacing={1}>
        <Typography variant="display300">{translate('Cargo Details')}</Typography>
      </Stack>
      {hasNonPoItems && <NonPurchaseOrderItems items={nonPurchaseOrderItems} /> }
      {hasPoItems &&
        <Stack spacing={2}>
          {hasPoItems && hasNonPoItems && <Divider sx={{ borderColor: theme.palette.divider }} />}
          <Box sx={{ paddingLeft: 2, paddingTop: '8px' }}>
            <Typography variant={'heading200'}>{translate('Purchase Order Items')}</Typography>
            <PurchaseOrderItemsHeader 
              cargoSummary={cargoSummary}
              innerPackQty={purchaseOrderItems
                .filter(item => item.innerPackQty !== undefined)
                .reduce((acc, item) => acc + (item.innerPackQty || 0), 0)}  
            />
          </Box>
          <PurchaseOrderItems items={purchaseOrderItems} />
        </Stack>
      }
    </Stack>
  );
};
